import SendEmail from "@/views/admin/settings/SendEmail";

export default {
  path: "settings/send-email",
  name: "settings-send-email",
  component: SendEmail
};
